import { colors } from "../../../data/colors";

export const deleteStyle = (value: boolean | undefined | null) => {
  return {
    textDecoration: value ? "line-through" : "none",
    color: value ? colors.grey : colors.black,
  };
};
